import { render } from "./Symbol.vue?vue&type=template&id=192d7012"
import script from "./Symbol.vue?vue&type=script&lang=js"
export * from "./Symbol.vue?vue&type=script&lang=js"
script.render = render

export default script